const routes = {
  createServiceType: 'service-type',
  getServiceTypes: 'service-type',
  getServiceTypeById: 'service-type/',
  updateServiceType: 'service-type/',
  deleteServiceType: 'service-type/',
};

export default routes